import * as types from '../mutation-types'
import Http from 'utils/http'
import Notify from 'utils/notify'
import { clearEventLoading, startEvent } from 'utils/pusher'
import { toConsole } from 'utils/logger'

export const all = ({ dispatch }, site, include = []) => {
	return Http.include(include).get(`sites/${site}/fermenters`).then(response => {
		dispatch(types.SET_FERMENTERS, response.body.data);
	});
}

export const reset = ({ dispatch }) => {
	dispatch(types.SET_FERMENTERS, [])
}

function pusherError(response) {
	toConsole(response);
	clearEventLoading();
	Notify.error('Failed to generate file, please try again later');
}

export const exportDashboardData = ({ dispatch }, site, include = []) => {
	startEvent('Dashboard');
	return Http.include(include).get(`sites/${site}/fermenters-export`).then(() => {}, pusherError);
}

export const exportHistory = ({ dispatch }, ferments = '') => {
	startEvent('History');
	return Http.get(`ferments/export-history?ferments=${ferments}`).then(() => {}, pusherError);
}

export const get = ({ dispatch }, id, site, include = []) => {
	return Http.include(include).get(`sites/${site}/fermenters/${id}`).then(response => {
		dispatch(types.SET_ACTIVE_FERMENTER, response.body.data);
	});
}

export const edit = ({ dispatch }, fermenter) => {
	dispatch(types.SET_ACTIVE_FERMENTER, fermenter);
}

export const clear = ({ dispatch }) => {
	dispatch(types.SET_ACTIVE_FERMENTER, {});
}

export const update = ({ dispatch }, site, fermenter) => {
	return Http.put(`sites/${site}/fermenters/${fermenter.id}`, fermenter);
}

export const favourite = ({ dispatch }, fermenter, site) => {
	return Http.post(`sites/${site}/fermenters/${fermenter}/favourite`);
}

export const store = ({ dispatch }, site, fermenter) => {
	return Http.post(`sites/${site}/fermenters`, fermenter).then(response => {
		dispatch(types.ADD_FERMENTER, response.body.data);
		dispatch(types.SET_ACTIVE_FERMENTER, response.body.data);
	});
}

export const destroy = ({ dispatch }, id, site) => {
	return Http.destroy(`sites/${site}/fermenters/${id}`);
}



// WEBPACK FOOTER //
// ./src/vuex/actions/fermenters.js